import { useState } from "react";

function SocialLink({ href, children }) {
  const [hovered, setHovered] = useState(false);
  return (
    <a
      href={href}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        color: "#ffffff",
        opacity: hovered ? 1 : 0.65,
        transition: "opacity 0.2s, transform 0.2s",
        transform: hovered ? "translateY(-2px)" : "translateY(0)",
        display: "flex",
        alignItems: "center",
      }}
    >
      {children}
    </a>
  );
}

function NavLink({ children }) {
  const [hovered, setHovered] = useState(false);
  return (
    <a
      href="#"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        color: hovered ? "#a78bfa" : "#9ca3af",
        fontSize: "0.88rem",
        fontWeight: 400,
        textDecoration: "none",
        transition: "color 0.2s",
      }}
    >
      {children}
    </a>
  );
}

function Footer() {
  return (
    <footer style={{
      background: "#13121f",
      padding: "0 clamp(16px, 5vw, 64px)",
      boxSizing: "border-box",
      
    }}>
      <div style={{ maxWidth: 1400, margin: "0 auto" }}>

        {/* Top divider */}
        <div style={{ height: 1, background: "#2d2a4a", marginBottom: "clamp(28px, 4vw, 48px)" }} />

        {/* Bottom divider */}
        <div style={{ height: 1, background: "#2d2a4a", marginBottom: "clamp(20px, 3vw, 28px)" }} />

        {/* Bottom bar — 3 items, responsive wrap */}
        <div style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "clamp(16px, 3vw, 24px)",
          paddingBottom: "clamp(24px, 4vw, 32px)",
        }}>

          {/* Copyright */}
          <span style={{
            fontSize: "clamp(0.78rem, 1.2vw, 0.88rem)",
            color: "#9ca3af",
            order: 1,
          }}>
            © 2025 elementuslabs. All rights reserved.
          </span>

          {/* Social icons — center */}
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "clamp(14px, 2.5vw, 20px)",
            order: 2,
          }}>
            {/* YouTube */}
            <SocialLink href="#">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.5 6.2s-.2-1.6-1-2.3c-.9-1-1.9-1-2.4-1C17.1 2.7 12 2.7 12 2.7s-5.1 0-8.1.2c-.5.1-1.5.1-2.4 1C.7 4.6.5 6.2.5 6.2S.3 8 .3 9.9v1.7c0 1.8.2 3.7.2 3.7s.2 1.6 1 2.3c.9 1 2.1.9 2.6 1 1.9.2 8 .2 8 .2s5.1 0 8.1-.2c.5-.1 1.5-.1 2.4-1 .8-.7 1-2.3 1-2.3s.2-1.8.2-3.7V9.9c0-1.9-.2-3.7-.2-3.7zM9.7 15.5V8.4l6.5 3.6-6.5 3.5z"/>
              </svg>
            </SocialLink>

            {/* LinkedIn */}
            <SocialLink href="#">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"/>
              </svg>
            </SocialLink>

            {/* Twitter/X */}
            <SocialLink href="#">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </SocialLink>
          </div>

          {/* Legal links */}
          <div style={{
            display: "flex",
            gap: "clamp(16px, 2.5vw, 24px)",
            order: 3,
          }}>
            {["Terms", "Privacy"].map((link) => (
              <NavLink key={link}>{link}</NavLink>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;